const Spacer = () => {
  return <div className="grow"></div>
}

export default Spacer
